import { Unstable_NumberInput as BaseNumberInput, NumberInputProps } from "@mui/base";
import { ForwardedRef, forwardRef } from "react";
import { StyledButton, StyledInputElement, StyledInputRoot } from "../../expanded-theme";

const CustomNumberInput = forwardRef(function CustomNumberInput(
    // props: InputProps,
    props: NumberInputProps & { isDecimal?: boolean | true },
    ref: ForwardedRef<HTMLDivElement>,
) {
    if (!props.isDecimal)
        return (
            <BaseNumberInput
                slots={{
                    root: StyledInputRoot,
                    input: StyledInputElement,
                    incrementButton: StyledButton,
                    decrementButton: StyledButton,
                }}
                slotProps={{
                    incrementButton: {
                        children: '▴',
                    },
                    decrementButton: {
                        children: '▾',
                    },
                }}
                {...props}
                ref={ref}
            />
        );

    return (
        <BaseNumberInput
            slots={{
                root: StyledInputRoot,
                input: StyledInputElement,
                incrementButton: StyledButton,
                decrementButton: StyledButton,
            }}
            slotProps={{
                incrementButton: {
                    children: '▴',
                },
                decrementButton: {
                    children: '▾',
                },
                input: {
                    inputMode: "decimal",
                    step: "any",
                },
            }}
            {...props}
            ref={ref}
        />
    );
});

export default CustomNumberInput;
